import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import type { AdminProfileHistoryCollection } from './admin-profile-history.types';

export function adminProfileHistoryBackend(): Backend<AdminProfileHistoryCollection> {
  return {
    defaultOrder: {
      field: 'updatedAt',
      direction: OrderByDirection.DESC,
    },
    fetch: (authUid, ids, query, order) => {
      let orderDirection: string | undefined;
      if (order) {
        orderDirection =
          order[0].direction === OrderByDirection.ASC ? 'ASC' : 'DESC';
      }

      return {
        endpoint: 'admin/profile-history/getHistory.php',
        isGaf: true,
        params: {
          user_id: getQueryParamValue(query, 'userId')[0],
          field_type: getQueryParamValue(query, 'fieldType')[0],
          limit: query?.searchQueryParams?.limit,
          offset: query?.searchQueryParams?.offset,
          order_direction: orderDirection,
        },
      };
    },
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
